module.exports = __webpack_public_path__ + "images/map-style-1-41730a101c24aac17e6a7f89a2017364.jpg";